export default __webpack_public_path__ + "static/media/android-white.c8dc95b3.svg";